import { studentMessages } from './lib/intl/en-US';
import { studentMessagesFR } from './lib/intl/fr-CA';

export const programId = '5dc4a7319472ea21d7c0de44';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': studentMessages,
        'fr-CA': studentMessagesFR,
    },
};
